import React from 'react';
import { Link } from 'react-router-dom';
import { EVENT_TYPE_LANDINGS } from '../../config/seoLandings';

/**
 * Verzeichnis der Landingpages am Ende der Event-Listen (29.10.2026). Ersetzt Einleitung,
 * FAQ und die ausgeschriebenen Bundesländer und Kantone: auf den Landings bekommt Googlebot ohnehin
 * das Server-HTML (`SeoPageController`, `nginx.conf.template`), die Startseite bringt 3,5 % der
 * Suchklicks, und Besucher kommen bei nachladender Liste kaum bis hierher. Bundesländer erreicht man
 * über die Landings und die Sitemap. Das `FAQPage`-Markup bleibt in `Landing.tsx` stehen.
 */
const GRUPPEN: { titel: string; links: { label: string; to: string }[] }[] = [
  { titel: 'Disziplin', links: [
    { label: 'Rennrad', to: '/rennrad-events' },
    { label: 'RTF', to: '/rtf-events' },
    { label: 'Gravel', to: '/gravel-events' },
    { label: 'MTB', to: '/mtb-events' },
  ] },
  { titel: 'Eventart', links: EVENT_TYPE_LANDINGS.map(l => ({ label: l.label, to: `/${l.slug}` })) },
  { titel: 'Außerdem', links: [
    { label: 'Radrennen in Österreich', to: '/radrennen-oesterreich' },
    { label: 'Radrennen in der Schweiz', to: '/radrennen-schweiz' },
    { label: 'Profi-Rennkalender', to: '/rennkalender' },
  ] },
];

const EventVerzeichnis: React.FC = () => (
  <nav className="event-verzeichnis" aria-label="Events entdecken">
    {GRUPPEN.map(g => (
      <div key={g.titel} className="event-verzeichnis-zeile">
        <h2>{g.titel}</h2>
        <ul>
          {g.links.map(l => <li key={l.to}><Link to={l.to}>{l.label}</Link></li>)}
        </ul>
      </div>
    ))}
  </nav>
);

export default EventVerzeichnis;
